module.exports = __webpack_public_path__ + "static/media/40k.52f1a730.svg";